module.exports = __webpack_public_path__ + "static/media/Team-invoice-pic-3.c2ca8473.png";